import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DonutChartProps {
  data: { symbol: string; amount?: number; proportion?: number }[];
}

const DonutChart: React.FC<DonutChartProps> = ({ data }) => {
  const total = data.reduce((sum, item) => sum + (item.proportion ?? item.amount ?? 0), 0);

  // ชุดสี Vibrant สำหรับ Dark Theme
  const colors = [
    '#3b82f6', // Blue
    '#22c55e', // Green
    '#eab308', // Yellow
    '#ef4444', // Red
    '#f97316', // Orange
    '#8b5cf6', // Purple
  ];

  const chartData = {
    labels: data.map((item) => item.symbol),
    datasets: [
      {
        data: data.map((item) =>
          (((item.proportion ?? item.amount ?? 0) / total) * 100)
        ),
        backgroundColor: colors,
        hoverBackgroundColor: colors,
        borderWidth: 0, // นำขอบสีขาวออกเพื่อให้ดู Seamless
        hoverOffset: 10,
        cutout: '70%', // ปรับความหนาของวงแหวนให้ดูเพรียว
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false, // ซ่อน Legend เพื่อความคลีนตามรูป
      },
    
      tooltip: {
        callbacks: {
          label: (context: any) => ` ${context.label}: ${context.raw.toFixed(2)}%`,
        },
        backgroundColor: '#18181b',
        titleColor: '#fff',
        bodyColor: '#fff',
        padding: 10,
        cornerRadius: 8,
        displayColors: true,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="relative" >
      <Doughnut data={chartData} options={options} />
      {/* ส่วนตรงกลางกราฟ ถ้าอยากใส่เปอร์เซ็นต์รวมหรือไอคอน */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        {/* <span className="text-[10px] font-bold text-gray-500 uppercase tracking-tighter">Total</span>
        <span className="text-sm font-black text-white">100%</span> */}
      </div>
    </div>
  );
};
 
export default DonutChart;